import React from 'react';
import { Lock, CheckCircle, Shield } from 'lucide-react';

const SecurityBadge = () => {
  return (
    <div className="bg-gradient-to-r from-pink-50 to-purple-50 rounded-lg p-6 border-2 border-pink-200 mb-8">
      <div className="flex items-center justify-center mb-4">
        <Shield className="w-8 h-8 text-pink-600 mr-3" />
        <h3 className="text-2xl font-bold text-gray-800">Secure Submission</h3>
      </div>
      
      <p className="text-center text-gray-700 mb-4 font-medium">
        Real-time security checks + manual validation
      </p>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
        <div className="flex items-start space-x-3">
          <CheckCircle className="w-5 h-5 text-green-600 mt-1 flex-shrink-0" />
          <div>
            <p className="text-sm font-semibold text-gray-800">Fraud Detection</p>
            <p className="text-xs text-gray-600">AI-powered security screening</p>
          </div>
        </div>
        
        <div className="flex items-start space-x-3">
          <Lock className="w-5 h-5 text-green-600 mt-1 flex-shrink-0" />
          <div>
            <p className="text-sm font-semibold text-gray-800">Encrypted Storage</p>
            <p className="text-xs text-gray-600">Bank-level data protection</p>
          </div>
        </div>
        
        <div className="flex items-start space-x-3">
          <Shield className="w-5 h-5 text-green-600 mt-1 flex-shrink-0" />
          <div>
            <p className="text-sm font-semibold text-gray-800">Duplicate Prevention</p>
            <p className="text-xs text-gray-600">Advanced verification system</p>
          </div>
        </div>
      </div>
      
      <div className="mt-4 pt-4 border-t border-pink-200">
        <p className="text-xs text-center text-gray-600">
          🔒 Your information is protected by advanced AI security systems and manual verification
        </p>
      </div>
    </div>
  );
};

export default SecurityBadge;
